/**
 * @fileoverview Validation functions for input validation.
 * @author jguiton
 */
goog.provide('gcm.validate');

/**
 * The interface that a commonUI object must implement
 * @type {Array.<string>}
 * @private
 */
gcm.validate.commonUIIface_ = [
  'stakeUpdate', 'paidUpdate', 'balancesUpdate',
  'gameAnimationStart', 'gameAnimationComplete',
  'gameReady', 'loadProgressUpdate',
  'regOption', 'optionHasChanged',
  'configReady', 'handleError'
];

/**
 * The interface that a 2.X+ commonUI object must implement
 * @type {Array.<string>}
 * @private
 */
gcm.validate.commonUIIfaceV2_ = [  
  'handleSessionStats',
  'handleFreebetAward',
  'handleBonusBarFilled',
  'handleBonusBarUpdate',
  'handleSessionDurationUpdate'
];

/**
 * The interface that a game object must implement
 * @type {Array.<string>}
 * @private
 */
gcm.validate.gameIface_ = [
  'gameRevealed', 'gcmReady', 'optionHasChanged',
  'configReady', 'resume', 'balancesHasChanged'
];


/**
 * Check that a commonUI object implements the required interface.
 * @param {Object} commonUI a commonUI object.
 * @return {Array.<string>} the result of the check.
 */
gcm.validate.isCommonUI = function(commonUI) {

  var rsltArr = [];
  var len = gcm.validate.commonUIIface_.length;
  for (var i = 0; i < len; i++) {
    var functionName = gcm.validate.commonUIIface_[i];
      if (typeof commonUI[functionName] !== 'function') {
        rsltArr.push(functionName);
      }
  }
  return rsltArr;
};


/**
 * Check that a commonUI object implements the 2.X interface.
 * @param {Object} commonUI a commonUI object.
 * @return {Array.<string>} the result of the check.
 */
gcm.validate.isCommonUIV2 = function(commonUI) {

  var rsltArr = [];
  var len = gcm.validate.commonUIIfaceV2_.length;
  for (var i = 0; i < len; i++) {
    var functionName = gcm.validate.commonUIIfaceV2_[i];
      if (typeof commonUI[functionName] !== 'function') {
        rsltArr.push(functionName);
      }
  }
  return rsltArr;
};

/**
 * Check that a game object implements the required interface.
 * @param {Object} game a game object.
 * @return {Array.<string>} the result of the check.
 */
gcm.validate.isGame = function(game) {

  var rsltArr = [];
  var len = gcm.validate.gameIface_.length;
  for (var i = 0; i < len; i++) {
    var functionName = gcm.validate.gameIface_[i];
    if (typeof game[functionName] !== 'function') {
      rsltArr.push(functionName);
    }
  }
  return rsltArr;
};

/**
 * Check the a balances object is in the correct format
 * @param {Object} balances object.
 * @return {boolean} the result of the check.
 */
gcm.validate.isBalances = function(balances) {
  //return false if it's null object
  if (!balances)
    return false;

  //balances must include at least a CASH balance
  if (typeof balances['CASH'] !== 'object') {
    return false;
  }

  for (var type in balances) {
    if (typeof balances[type]['amount'] !== 'number') {
      return false;
    }
  }
  return true;
};

/**
 * Check that a errorInfo contains the correct properties.
 * @param {Object} errorInfo an errorInfo object.
 * @return {boolean} the result of the check.
 */
gcm.validate.isErrorInfo = function(errorInfo) {
  if (!errorInfo) {
    return false;
  }

  return !(typeof errorInfo['errorCode'] == 'undefined' || typeof errorInfo['errorMessage'] == 'undefined');
};

/**
 * Check the a accountInfo ccy params are in the correct format
 * CCY code can be empty.
 *
 * @param {Object} accountInfo object.
 * @return {boolean} the result of the check.
 */
gcm.validate.isValidCurrencyOps = function(accountInfo) {

  if (!accountInfo)
    return false;

  var patternSeparator = /^[\D]$/;
  var patternCCY = /^[\D]*$/;

  return patternSeparator.test(accountInfo['ccy_thousand_separator']) &&
    patternSeparator.test(accountInfo['ccy_decimal_separator']) &&
    patternCCY.test(accountInfo['ccy_code']);
};

/**
 * Check the input is numeric
 * @param {number} value the number to validate.
 * @return {boolean} the result of the check.
 */
gcm.validate.isNumericValue = function(value) {
  return (typeof value) == 'number' && !isNaN(parseFloat(value)) && isFinite(value);
};


/**
 *
 * @param {number} value the number to validate.
 * @return {boolean} the result of the check.
 */
gcm.validate.isIntegerValue = function(value) {

  return (typeof value) == 'number' && !isNaN(parseInt(value, 10)) && parseInt(value, 10) == value && isFinite(value);
};


/**
 * @param {number} value the percentage value to validate.
 * @return {boolean} the result of the check.
 */
gcm.validate.isPercentValue = function(value) {

  if (gcm.validate.isNumericValue(value)) {
    return (parseFloat(value) <= 100) && !(parseFloat(value) < 0);
  }
  return false;
};

/**
 * Checks that the input is a valid css height spec.
 * valid units: %,in,cm,mm,em,ex,pt,pc,px
 *
 * @param {string} value the number to validate.
 * @return {boolean} the result of the check.
 */
gcm.validate.isHeight = function(value) {
  var height = /^\d+(\.\d+)?(%|in|cm|mm|em|ex|pt|pc|px)/;
  return height.test(value);
};


/**
 * Checks that this is a string of non zero length with only letters and numbers
 * @param {string} str the value to validate.
 * @return {boolean} the result of the check.
 */
gcm.validate.isAlphaNumeric = function(str) {
  if (typeof str != 'string')
    return false;

  return /^[a-zA-Z0-9]+$/.test(str);
};

/**
 * Checks that string is valid game name
 * @param {string} str the value to validate.
 * @return {boolean} the result of the check.
 */
gcm.validate.isValidGameName = function(str) {
  if (typeof str != 'string')
    return false;

  return /^[a-zA-Z0-9\-_]+$/.test(str);
};

/**
 * Checks that string is valid language
 * language can be just a 
 * @param {string} str the value to validate.
 * @return {boolean} the result of the check.
 */
gcm.validate.isValidLanguage = function(str) {
  if (typeof str != 'string')
    return false;

  var lang_array = str.split("-");
  var patternLanguage = /^[a-z]{2}$/;

  if (lang_array.length === 1)
    return patternLanguage.test(lang_array[0]);

  if (lang_array.length === 2) {
    var patternCountry = /^[A-Z]{2}$/;
    return patternLanguage.test(lang_array[0]) && patternCountry.test(lang_array[1]);
  }

  // otherwise
  return false;
};

/**
 * Checks the string is a single letter. Useful for checking channels
 * @param {string} str the value to validate.
 * @return {boolean} the result of the check.
 */
gcm.validate.isSingleLetter = function(str) {
  return /^[a-zA-Z]$/.test(str);
};


/**
 * Checks the string is a single digit. Useful for checking channels
 * @param {string} str the value to validate.
 * @return {boolean} the result of the check.
 */
gcm.validate.isSingleDigit = function(str) {
	  return /^[0-9]$/.test(str);
};


/**
 * @param {Object} optionTypes enum of valid options.
 * @param {string} optionType for validation.
 * @return {boolean} the result of the check.
 */
gcm.validate.isEnumOption = function(optionTypes, optionType) {

  /**
   * @type {boolean}
   */
  var found = false;
  for (var key in optionTypes) {
    if (optionType === optionTypes[key]) {
      found = true;
      break;
    }
  }
  return found;
};

/**
 * @param {Object} callBack function passed through.
 * @return {boolean} the result.
 */
gcm.validate.isFunction = function(callBack) {
  return typeof callBack === 'function';

};



/**
 * @param {Element} elem value to be validated.
 * @return {boolean} Is the object a DOM element.
 */
gcm.validate.isElement = function(elem) {
  return Boolean(elem && typeof elem.appendChild === 'function');

};
